<app-common-header-layout
  [trackingScreenName]="trackingScreenName"
  [trackingObject]="trackingObject$ | async"
>
  <div class="message-container">
    <div class="success-icon-wrapper">
      <i2g-icon class="success-icon" [icon]="successIcon"> </i2g-icon>
    </div>

    <h1 class="title">
      {{ 'CHANGE_EMAIL.SUCCESS_TITLE' | translate }}
    </h1>

    <h2 class="sub-title">
      {{ 'CHANGE_EMAIL.SUCCESS_MESSAGE' | translate }}
    </h2>

    <i2g-router-link
      class="action"
      buttonStyle="emphasis"
      [route]="loginRoute.route"
      [label]="loginRoute.label"
      [trackingObject]="trackingObject$ | async"
      [trackingAction]="loginRoute.trackingAction"
      [alignment]="alignmentEnum.center"
    >
    </i2g-router-link>
  </div>
</app-common-header-layout>
